import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { leaveGame } from '@/domains/game/api'
import { useGameStore } from '@/domains/game/store'
import { PokerTable } from '@/domains/game/components/PokerTable'
import { PokerSeats } from '@/domains/game/components/PokerSeats'
import { AwaitingPlayersDialog } from '@/domains/game/components/AwaitingPlayersDialog'
import { CommunityCards } from '@/domains/game/components/CommunityCards'
import { ShowdownRankings } from '@/domains/game/components/ShowdownRankings'

export const Route = createFileRoute('/game/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { fetchGame, isLoading, game, error } = useGameStore()
  const isMountedRef = useRef(false)

  useEffect(() => {
    isMountedRef.current = true

    fetchGame(id)

    return () => {
      isMountedRef.current = false
      // Wait a frame to see if React remounts (Strict Mode)
      requestAnimationFrame(() => {
        if (!isMountedRef.current) {
          leaveGame(id)
        }
      })
    }
  }, [id])

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (error || !game) {
    return <div>Error: {error}</div>
  }

  return (
    <div className="flex-1 flex items-start justify-center px-6">
      <AwaitingPlayersDialog />
      <PokerTable>
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 z-0">
          <ShowdownRankings />
          <CommunityCards />
        </div>
        <PokerSeats game={game} />
      </PokerTable>
    </div>
  )
}
